import React from 'react';
import { Truck, Sparkles } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { tx } from '@/translations/translations';

/**
 * Thin marquee-style announcement bar that lives at the very top of the page.
 * Mobile: a single non-scrolling line (kept short)
 * Desktop: 2 messages with an animated dot separator
 */
const AnnouncementBar = () => {
  const { language } = useLanguage();

  const msg1 = tx(language, 'Envío GRATIS al llevar 5 productos', 'FREE shipping when you buy 5 products', 'משלוח חינם בקניית 5 מוצרים');
  const msg2 = tx(language, 'Envíos a todo México', 'We ship throughout Mexico', 'משלוחים לכל מקסיקו');

  return (
    <div className="bg-gradient-to-r from-emerald-500 via-green-500 to-emerald-500 text-white text-xs sm:text-sm font-semibold shadow-md">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2 sm:py-2.5 flex items-center justify-center gap-2 sm:gap-4 tracking-wide">
        <Truck className="w-4 h-4 flex-shrink-0 drop-shadow" />
        <span className="truncate">
          {msg1}
        </span>
        <span className="hidden sm:inline-flex items-center gap-2">
          <span className="w-1 h-1 rounded-full bg-white/60" />
          <Sparkles className="w-3.5 h-3.5" />
          <span>{msg2}</span>
        </span>
      </div>
    </div>
  );
};

export default AnnouncementBar;
